import {Customer, Maybe} from '../api/generated';
import {formatEmail, formatPhone} from '../lib/formaters';
import {PropertyList} from './PropertyList';
import React from 'react';

export const CustomerBlock: React.FC<{customer: Customer; countryCode?: Maybe<string>}> = ({
  customer,
  countryCode
}) => {
  return (
    <PropertyList
      omitEmpty
      properties={[
        {label: 'Name', value: customer?.name},
        {label: 'Email', value: formatEmail(customer?.email)},
        {
          label: 'Phone',
          value: formatPhone(customer?.phone, countryCode, true)
        }
      ]}
    />
  );
};
